import { AskAlpharunModal } from "@repo/ui/chat/askAlpharunModal";
import type { FC } from "react";
import { CopilotChatView } from "./copilotChatView.js";
import type { CopilotProps } from "./copilotContext.js";
import { CopilotHistoryView } from "./copilotHistoryView.js";

export interface CopilotExpandedModalProps {
  copilot: CopilotProps;
}

/**
 * The expanded (near-fullscreen) copilot chat: a history rail beside
 * the conversation, in a dismissable modal driven by the provider's
 * `isModalOpen` state.
 */
export const CopilotExpandedModal: FC<CopilotExpandedModalProps> = ({
  copilot,
}) => (
  <AskAlpharunModal
    isOpen={copilot.isModalOpen}
    onOpenChange={copilot.onModalOpenChange}
    history={
      <CopilotHistoryView
        surface="modalSidebar"
        resourceId={copilot.resourceId}
        selectedThreadId={copilot.threadId}
        onThreadSelect={copilot.onThreadSelect}
        onNewThreadSelect={() => copilot.onNewThreadSelect()}
      />
    }
  >
    <CopilotChatView
      copilotChat={copilot}
      surface="modal"
      onRequestClose={copilot.onCloseChat}
    />
  </AskAlpharunModal>
);
